import { useContext } from "use-context-selector";
import { SubcountryContext } from "../providers/subcountry";

const useSubcountry = () => {
  return useContext(SubcountryContext);
};

export default useSubcountry;
